module.exports = __webpack_public_path__ + "img/message-setting.02241d06.png";